import React from 'react'
import { AppProvider } from 'App'

export const wrapRootElement = ({ element }) => <AppProvider>{element}</AppProvider>
